import { render } from "./StaticsChart.vue?vue&type=template&id=4168a3c3&scoped=true"
import script from "./StaticsChart.vue?vue&type=script&lang=js"
export * from "./StaticsChart.vue?vue&type=script&lang=js"

import exportComponent from "/Users/qinzilie/INFURA-UI/infura-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4168a3c3"]])

export default __exports__